import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import SimpleApp from "./components/SimpleApp";

// Check if we're in simple.html (has simple-root) or main site (has root)
const simpleRoot = document.getElementById("simple-root");
const mainRoot = document.getElementById("root");

if (simpleRoot) {
  // Render SimpleApp for iframe/simple view
  createRoot(simpleRoot).render(<SimpleApp />);
} else if (mainRoot) {
  // Render main App for normal site
  createRoot(mainRoot).render(<App />);
}
